module.exports = __webpack_public_path__ + "img/arch-photo--.36d5c1c0.jpg";